import request from '@/utils/request'
import store from '../store'
import { requestHost, qmRequestHost } from '@/utils/hostsconfig'
import { getQueryString } from '@/utils'

const appName = getQueryString('app_name') || sessionStorage.getItem('supervise_app_name') || '';
const APP_HOST_MAP = { qimeng: qmRequestHost };

const BASE_URL = APP_HOST_MAP[appName] || requestHost;

const isProduction = !window.location.host.includes('test');
const MBASE_URL = isProduction
  ? 'https://m.songshuai.com/api'
  : 'https://m.test.songshuai.com/api'; // 测试环境
  // 获取校区logo
 const  getChannelInfo = params => {
    return request({
      url: `${MBASE_URL}/school/getChannelInfo`,
      method: 'post',
      data: params,
    });
  }

// 分析员登录
const login = data => {
  return request({
    url: BASE_URL + '/login/login',
    method: 'post',
    data
  })
}

// 分析员退出
export const logout = data => {
  return request({
    url: BASE_URL + '/login/logout',
    method: 'post',
    data
  })
}

// 查询功能限制
const queryLimit = data => {
  return request({
    url: BASE_URL + "/teacher/queryLimit",
    method: "post",
    data
  });
};

// 获取多个信息
const getMultiInfo = data => {
  return request({
    url: BASE_URL + '/teacher/getMultiInfo',
    method: 'post',
    data
  })
}

// 批量获取多个信息
const getMultiInfoBatch = data => {
  return request({
    url: BASE_URL + '/teacher/getMultiInfoBatch',
    method: 'post',
    data
  })
}

// 设置学生状态
const setStudentStatus = data => {
  return request({
    url: BASE_URL + '/teacher/setStudentStatus',
    method: 'post',
    data
  })
}

// 获取分析员学科课程列表
const getCourseList = data => {
  return request({
    url: BASE_URL + '/teacher/getCourseList',
    method: 'post',
    data
  })
}

// 获取用户信息
const getUserInfo = data => {
  return request({
    url: BASE_URL + '/user/getUserInfo',
    method: 'post',
    data
  })
}

// 分页获取用户课程报告列表
const getReportList = data => {
  return request({
    url: BASE_URL + '/user/getReportList',
    method: 'post',
    data
  })
}

// 获取课程信息
const getCourseInfo = data => {
  return request({
    url: BASE_URL + '/course/getCourseInfo',
    method: 'post',
    data
  })
}

// 获取课次信息
const getLessonInfo = data => {
  return request({
    url: BASE_URL + '/course/getLessonInfo',
    method: 'post',
    data
  })
}

// 获取专题信息
const getTopicInfo = data => {
  return request({
    url: BASE_URL + '/course/getTopicInfo',
    method: 'post',
    data
  })
}

// 获取课程课次任务卡列表
const getCourseTree = data => {
  return request({
    url: BASE_URL + '/course/getCourseTree',
    method: 'post',
    data
  })
}

// 获取学习模块列表
const getModuleList = data => {
  return request({
    url: BASE_URL + '/course/getModuleList',
    method: 'post',
    data
  })
}

// 获取知识点信息
const getKnowledgeInfo = data => {
  return request({
    url: BASE_URL + '/cms/getKnowledgeInfo',
    method: 'post',
    data
  })
}

// 批量获取知识点信息
const getKnowledgeInfoBatch = data => {
  return request({
    url: BASE_URL + '/cms/getKnowledgeInfoBatch',
    method: 'post',
    data
  })
}

// 获取知识点详细信息
const getDetailKnowledgeInfo = data => {
  return request({
    url: BASE_URL + '/cms/getDetailKnowledgeInfoV3',
    method: 'post',
    data
  })
}

// 获取知识点列表
const getKnowledgeList = data => {
  return request({
    url: BASE_URL + '/cms/getKnowledgeList',
    method: 'post',
    data
  })
}

// 获取用户统计信息
const userStatInfo = data => {
  return request({
    url: BASE_URL + '/stat/userStatInfo',
    method: 'post',
    data
  })
}

// 获取知识点列表
const userWeakKnowledgeList = data => {
  return request({
    url: BASE_URL + '/stat/userWeakKnowledgeList',
    method: 'post',
    data
  })
}
// 获取知识点列表
export const getDetailKnowledgeInfoV3 = data => {
  return request({
    url: BASE_URL + '/cms/getDetailKnowledgeInfoV3',
    method: 'post',
    data
  })
}

// 分页获取共性答题列表
const commonErrorQuestionList = data => {
  return request({
    url: BASE_URL + '/stat/commonErrorQuestionList',
    method: 'post',
    data
  })
}

// 获取共性答题详情
const commonErrorQuestionInfo = data => {
  return request({
    url: BASE_URL + '/stat/commonErrorQuestionInfo',
    method: 'post',
    data
  })
}

// 分页获取共性薄弱知识点列表
const commonWeakKnowledgeList = data => {
  return request({
    url: BASE_URL + '/stat/commonWeakKnowledgeList',
    method: 'post',
    data
  })
}

// 获取共性薄弱知识点详情
const commonWeakKnowledgeInfo = data => {
  return request({
    url: BASE_URL + '/stat/commonWeakKnowledgeInfo',
    method: 'post',
    data
  })
}

// 获取当前答题详情
const getQuestionInfo = data => {
  return request({
    url: BASE_URL + '/question/getQuestionInfo',
    method: 'post',
    data
  })
}


// 获取当前答题详情
export const getQuestionInfoV3 = data => {
  return request({
    url: BASE_URL + '/question/getQuestionInfoV3',
    method: 'post',
    data
  })
}
// 分页获取学生历史答题列表
const getUserQuestionList = data => {
  return request({
    url: BASE_URL + '/question/getUserQuestionListV3',
    method: 'post',
    data
  })
}

// 获取学生历史答题详情
const getUserQuestionInfo = data => {
  return request({
    url: BASE_URL + '/question/getUserQuestionInfoV3',
    method: 'post',
    data
  })
}

// 获取待批改主观题列表
const getSubjectiveQuestionList = data => {
  return request({
    url: BASE_URL + '/question/getSubjectiveQuestionList',
    method: 'post',
    data
  })
}


// 获取待批改主观题详情
const getSubjectiveQuestionInfo = data => {
  return request({
    url: BASE_URL + '/question/getSubjectiveQuestionInfo',
    method: 'post',
    data
  })
}

// 批改语文主观题
const correctCnSubjective = data => {
  return request({
    url: BASE_URL + '/question/correctCnSubjective',
    method: 'post',
    data
  })
}

// 批改英语主观题
const correctEnSubjective = data => {
  return request({
    url: BASE_URL + '/question/correctEnSubjective',
    method: 'post',
    data
  })
}

// 保存分析员错因标记
const saveErrorReason = data => {
  return request({
    url: BASE_URL + '/question/saveErrorReason',
    method: 'post',
    data
  })
}

// 分页获取学生课堂回放列表
const getUserActList = data => {
  return request({
    url: BASE_URL + '/question/getUserActList',
    method: 'post',
    data
  })
}

// 获取跳过不学反馈配置列表
const getConfigList = data => {
  return request({
    url: BASE_URL + '/feedback/getConfigList',
    method: 'post',
    data
  })
}

// 保存跳过不学反馈
const saveSkipFeedback = data => {
  return request({
    url: BASE_URL + '/feedback/saveSkipFeedback',
    method: 'post',
    data
  })
}

// 查询某个学区的学生列表
const searchUserList = data => {
  return request({
    url: BASE_URL + '/feedback/searchUserList',
    method: 'post',
    data
  })
}

// 查询学生的课程信息
const studentCourseList = data => {
  return request({
    url: BASE_URL + '/feedback/studentCourseList',
    method: 'post',
    data
  })
}

// 搜索学生列表
const searchInviteUserList = data => {
  return request({
    url: BASE_URL + '/user/searchUserList',
    method: 'post',
    data
  })
}

// 学生课程列表
const getUserCourseList = data => {
  return request({
    url: BASE_URL + '/user/getCourseList',
    method: 'post',
    data
  })
}

// 检查学生是否在线
const checkStudentOnline = data => {
  return request({
    url: BASE_URL + '/teacher/checkStudentOnline',
    method: 'post',
    data
  })
}


// 上传大模型数据看板查看答案记录
const addViewAnswerLog = data => {
  return request({
    url: BASE_URL + '/teacher/addViewAnswerLog',
    method: 'post',
    data
  })
}


// 历史错题手写板图片
const getBoardImg = params => {
  return request({
    url: BASE_URL + "/question/getBoardImg",
    method: "post",
    data: params
  });
};

// 获取授权用户数量
const getAuthUserCount = params => {
  return request({
    url: BASE_URL + "/teacher/getAuthUserCount",
    method: "post",
    data: params
  });
};

// 上传大模型数据看板记录
const addSuperintendLog = params => {
  return request({
    url: BASE_URL + "/teacher/addSuperintendLog",
    method: "post",
    data: params
  });
};

// 上传大模型数据看板互动记录
const addInteractLog = params => {
  return request({
    url: BASE_URL + "/teacher/addInteractLog",
    method: "post",
    data: params
  });
};
// 签到状态查询
export const getSignStatusForSupervisor = params => {
  return request({
    url: BASE_URL + "/coinmall/getSignStatusForSupervisor",
    method: "post",
    data: params
  });
};
// 签到状态查询
export const supervisorSign = params => {
  return request({
    url: BASE_URL + "/coinmall/supervisorSign",
    method: "post",
    data: params
  });
};
// 分析员的金币数
export const getSupervisorCoins = params => {
  return request({
    url: BASE_URL + "/coinmall/getSupervisorCoins",
    method: "post",
    data: params
  });
};
// 批量奖励-金币管理
export const getReward = params => {
  return request({
    url: BASE_URL + "/highlights/reward",
    method: "post",
    data: params
  });
};
// 批量奖励-金币管理
export const getRewardOnAccount = params => {
  return request({
    url: BASE_URL + "/coinmall/rewardOnAccount",
    method: "post",
    data: params
  });
};
// 分析员分配二维码
export const agentAssignQrCode = params => {
  return request({
    url: BASE_URL + "/coinmall/agentAssignQrCode",
    method: "post",
    data: params
  });
};
// 到小程序购买二维码
export const buyCoinQrCode = params => {
  return request({
    url: BASE_URL + "/coinmall/buyCoinQrCode",
    method: "post",
    data: params
  });
};
// 公众号推送消息
export const sendAssignApplyNotice = params => {
  return request({
    url: BASE_URL + "/coinmall/sendAssignApplyNotice",
    method: "post",
    data: params
  });
};
// 奖励学员金币
export const giftGoldCoinToStudent = params => {
  return request({
    url: BASE_URL + "/coinmall/giftGoldCoinToStudent",
    method: "post",
    data: params
  });
};
// 查询金币奖励规则
export const queryCoinGiftRule = params => {
  return request({
    url: BASE_URL + "/coinmall/queryCoinGiftRule",
    method: "post",
    data: params
  });
};
// 获取视频通话二维码
const getVideoQrCode = params => {
  return request({
    url: BASE_URL + "/teacher/getVideoQrCode",
    method: "post",
    data: params
  });
};

// 获取视频通话二维码
const checkAccountDeprived = params => {
  return request({
    url: BASE_URL + "/restriction/checkAccountDeprived",
    method: "post",
    data: params
  });
};

// PersonReminder-单个学生提醒
export const personReminder = data => {
  return request({
    url: BASE_URL + "/scoreCollection/personReminder",
    method: "post",
    data
  });
};

// FocreReminder-强制提醒
export const forceReminder = data => {
  return request({
    url: BASE_URL + "/scoreCollection/forceReminder",
    method: "post",
    data
  });
};

export {
  addViewAnswerLog,
  addSuperintendLog,
  addInteractLog,
  getChannelInfo,
  login,
  queryLimit,
  getMultiInfo,
  getMultiInfoBatch,
  setStudentStatus,
  getCourseList,
  getUserInfo,
  getReportList,
  getCourseInfo,
  getLessonInfo,
  getTopicInfo,
  getCourseTree,
  getModuleList,
  getKnowledgeInfo,
  getKnowledgeInfoBatch,
  getDetailKnowledgeInfo,
  getKnowledgeList,
  userStatInfo,
  userWeakKnowledgeList,
  commonErrorQuestionList,
  commonErrorQuestionInfo,
  commonWeakKnowledgeList,
  commonWeakKnowledgeInfo,
  getQuestionInfo,
  getUserQuestionList,
  getUserQuestionInfo,
  getSubjectiveQuestionList,
  getSubjectiveQuestionInfo,
  correctCnSubjective,
  correctEnSubjective,
  saveErrorReason,
  getUserActList,
  getConfigList,
  saveSkipFeedback,
  searchUserList,
  studentCourseList,
  searchInviteUserList,
  getUserCourseList,
  checkStudentOnline,
  getBoardImg,
  getAuthUserCount,
  getVideoQrCode,
  checkAccountDeprived
}



// WEBPACK FOOTER //
// ./src/api/base.js